import { Box, Button } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { ConditionalWrapper } from "../../generic/components/conditional-wrapper";
import { HoverBadge } from "../hover-badge";
import type { PreviewProps } from "./types";

export const HeaderTextPreview: FC<PreviewProps> = (props) => {
  const { t } = useTranslation();

  const { header } = props.data;

  return (
    <Box sx={{ width: "100%" }}>
      <ConditionalWrapper
        condition={props.badgeProps !== undefined}
        wrapper={(children) => (
          <HoverBadge badgeContent={t("Text")} name="header_text" {...props.badgeProps}>
            {children}
          </HoverBadge>
        )}
      >
        <Button
          data-analytics-id="email-design-header-text-preview"
          sx={{
            width: "100%",
            justifyContent: header?.text?.align,
            color: header?.text?.color,
          }}
        >
          {header?.text?.value || t("Your header text here")}
        </Button>
      </ConditionalWrapper>
    </Box>
  );
};
